export default __webpack_public_path__ + "static/media/她秀.836be615.png";